document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  var newsletterForms = document.querySelectorAll('[data-newsletter-form]');
  newsletterForms.forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) btn.textContent = 'Zapisano ✓';
    });
  });
});
